import { Component, effect, inject, input, OnDestroy } from '@angular/core';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { VoucherFull } from '../../../models/voucherFull';
import { FormValidatorModule } from '../../../shared/form-validator/form-validator.module';
import { FormControl, FormsModule, Validators } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { SharedModule } from '../../../shared/shared.module';
import { MatLine } from '@angular/material/core';
import { UserPermissionDirective } from '../../../shared/directives/user-permission.directive';
import { LogService } from '../../../services/log.service';
import { DownloadLogStatus } from '../../../../../common/interfaces/DownloadLogStatus';
import { repeat, Subscription, switchMap, takeWhile, tap } from 'rxjs';

@Component({
  selector: 'app-voucher-client-installation',
  imports: [
    MatCard,
    MatCardTitle,
    MatCardContent,
    TranslateModule,
    FormValidatorModule,
    FormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    SharedModule,
    MatLine,
    UserPermissionDirective
  ],
  templateUrl: './voucher-client-installation.component.html',
  styleUrl: './voucher-client-installation.component.scss',
  standalone: true
})
export class VoucherClientInstallationComponent implements OnDestroy {
  private logService = inject(LogService);

  voucher = input.required<VoucherFull>();

  downloadLogStatus: DownloadLogStatus = 'NO_LOG';

  formControlInstaces = new FormControl<number>(0, {
    validators: Validators.required,
    nonNullable: true
  });
  disableModifyInstances = true;

  private pollingInterval = 5000; // ms

  private subscription = new Subscription();

  constructor() {
    effect(() => {
      this.logService.checkLogIsReady(this.voucher().code).subscribe((res) => {
        this.downloadLogStatus = res;
        if (res === 'UPLOADING') {
          this.startPollingLogStatus(this.voucher().code);
        }
      });
    });
  }

  private startPollingLogStatus(codeVoucher: string) {
    const sub$ = this.logService
      .checkLogIsReady(codeVoucher)
      .pipe(
        switchMap(() => {
          return this.logService.checkLogIsReady(codeVoucher).pipe(
            repeat({ delay: this.pollingInterval }),
            tap((res) => (this.downloadLogStatus = res)),
            takeWhile((res) => res !== 'READY', true)
          );
        })
      )
      .subscribe();

    this.subscription.add(sub$);
  }

  logRequest() {
    this.logService.requireLog(this.voucher().code).subscribe(() => this.startPollingLogStatus(this.voucher().code));
  }

  downloadLog() {
    this.logService.downloadLog(this.voucher().code).subscribe({
      next: (res) => {
        const blob = new Blob([res.blob], {
          type: 'application/octet-stream'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = res.fileName;
        link.click();
      },
      error: (error) => console.error('Errore nel download del file:', error)
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
